import { render, staticRenderFns } from "./404.vue?vue&type=template&id=7544a1bb&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=7544a1bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports